import { getLinearSettings } from "./helper.ts";
import type { ChartStyleSettings } from "../../../../../../../api/types/svTypes.ts";

export function isRotated(settings: ChartStyleSettings) {
  return getLinearSettings(settings)?.rotated === true;
}
